import React from "react";
import AppContainer from "../../../components/AppContainer";
import ExportButton from "../../../components/ExportButton";
import { MenuItem, Stack } from "@mui/material";
import CustomRangePicker from "../../../components/DateRangePicker";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/education/EducationNewAdmissions.json";
import CustomDropDown from "../../../components/CutomDropDown";
import CustomSelect from "../../../components/customSelect";
import { allIcons } from "../../../assets";

const allClasses = ["Class 1", "Class 2", "Class 3", "Class 4"];
const AdmissionType = ["Pay All", "Installment"];
const AdmissionSource = ["Walk In", "Online"];
const FeesStatus = ["Paid", "Remain", "Not Paid"];

const headerData = [
  "ID",
  "Join Date",
  "Student Detail",
  "Source",
  "Class",
  "Admission Fee",
  "Payment Type",
  "Status",
  "Action",
];

const displayRows = [
  "_id",
  "date_time",
  "ed_student_detail",
  "source",
  "ed_student_class",
  "ed_student_fee",
  "ed_fess_payment_type",
  "ed_fess_payment_status",
  "actions",
];

const AllAdmissions = () => {
  // Render top right part on template
  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <ExportButton handleClick={() => console.log("helllo")} />
        <CustomRangePicker
          stackProps={{
            borderRadius: "6px",
            border: "1px solid #dddddd",
          }}
        />
      </Stack>
    );
  };

  // Render multiple selections

  const renderMultipleSelections = () => {
    return (
      <Stack flex={1} direction={"row"} alignItems={"center"} gap={1}>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.classBlackIcon} width={16} />}
          placeholder={"By Class"}
        >
          {allClasses.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.cashBundleBlackIcon} width={16} />}
          placeholder={"Admission Fee"}
        >
          {AdmissionType.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.timerBlackIcon} width={16} />}
          placeholder={"Source"}
        >
          {AdmissionSource.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "20%" }}
          icon={<img src={allIcons.timerBlackIcon} width={16} />}
          placeholder={"Status"}
        >
          {FeesStatus.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"All Admissions"}
      secondaryHeading={"View, add, edit and delete admissions."}
      headProps={renderRightPart()}
      showSerach={true}
      searchMenuProps={renderMultipleSelections()}
    >
      <DynamicTable
        minWidth={1200}
        tableHeader={headerData}
        displayRows={displayRows}
        tableData={TableData}
        showActions={true}
        showEdit={true}
      />
    </AppContainer>
  );
};

export default AllAdmissions;
